<div class="bg-fill bg-orange">
  <h2 class="brand">Just Write</h2>
  <h1 class="">Check it out on a computer :)</h1>
  <p>This app was designed for writers looking for a great writing interface. This means the app was designed to work on a larger screen with a real keyboard. If you think you have reached this message by mistake, <a routerLink="/dashboard">click here</a> to continue to the app.</p>
</div>>
